<template>
<div class="duration-container">
    <template v-if="enabledDurations.length">
        <div class="duration-option"
            v-for="duration in durations"
            :key="duration"
            :class="{
                'bg-primary': activeReservation.selectedDuration == duration,
                'disabled': disabledDuration(duration)
            }"
            @click="selectDuration(duration)">
            <p>{{ durationToString(duration) }}</p>
            <p>{{ $_formatCurrency(price(duration)) }} {{ $_CURRENCY_SYMBOL }}</p>
        </div>
    </template>
    <template v-else>
        <h4>{{ $_locale('%s is not available', true, $_locale('reservation')) }}</h4>
    </template>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        additionalReservations: {
            type: Array,
            required: false,
            default: () => ([]),
        },
    },
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
            activeReservation: 'calendar/activeReservation',
            minuteRules: 'reservations/minuteRules',
            resourceRules: 'reservations/resourceRules',
        }),
        durations() {
            const [ rule ] = this.minuteRules

            return Object.keys(rule.ruleValue)
                .map(row => parseInt(row))
                .filter(isFinite)
        },
        enabledDurations() {
            const distanceToEnd = this.activeReservation.distanceToEnd()
            const distanceToDisabledBlock = this.activeReservation.distanceToDisabledBlock()
            const durations = this.durations

            return durations.filter(row => {
                if (distanceToEnd < row) return false;
                if (distanceToDisabledBlock < row) return false;

                return true;
            })
        },
        disabledDuration() {
            const enabledDurations = this.enabledDurations;

            return (duration) => !enabledDurations.includes(duration);
        },
        price() {
            const [ rule ] = this.minuteRules

            return (duration) => rule.ruleValue[duration]
        },
        durationToString() {
            return (minutes) => {
                if (minutes < 60) {
                    return `${ minutes }min`
                }
                let readable = `${ Math.floor(minutes / 60) }h`;
                
                const scraps = minutes % 60;

                if (scraps > 0) {
                    readable += ` ${ scraps }min`;
                }
                
                return readable;
            }
        },
    },
    methods: {
        selectDuration(duration) {
            if (this.disabledDuration(duration)) return;

            this.activeReservation.selectMinutes(duration)
        },
    },
    mounted() {
        this.$nextTick(() => this.selectDuration(this.enabledDurations[0]))
    }
}
</script>

<style scoped>
.duration-container {
    display: flex;
    position:relative;
    overflow-x: auto;
    margin-bottom: 17px;
}
</style>